<template>
  <!-- Footer -->
  <div
    v-if="$route.path !== '/maung-fb' && $route.path !== '/body-fb'"
    class="footer"
  >
    <ul class="nav justify-content-between align-items-center">
      <li
        class="nav-item"
        @click="() => {
          if ($route.path !== '/home') {
            $router.push('/home')
          }
        }"
      >
        <div class="nav-link">
          <i
            class="fas fa-home nav-icon"
            :class="{ active: linkIsActive('/home') }"
          ></i>
          <span
            class="nav-text"
            :class="{ active: linkIsActive('/home') }"
          >
            {{ $t('footer.home') }}
          </span>
        </div>
      </li>

      <li
        class="nav-item"
        @click="() => {
          if ($route.path !== '/promotion') {
            $router.push('/promotion')
          }
        }"
      >
        <div class="nav-link">
          <i
            class="fas fa-bullhorn nav-icon"
            :class="{ active: linkIsActive('/promotion') }"
          ></i>
          <span
            class="nav-text"
            :class="{ active: linkIsActive('/promotion') }"
          >
            {{ $t('footer.promotion') }}
          </span>
        </div>
      </li>

      <li
        class="nav-item"
        @click="() => {
          if ($route.path !== '/withdraw') {
            $router.push('/withdraw')
          }
        }"
      >
        <div class="nav-link">
          <i
            class="fas fa-wallet nav-icon"
            :class="{ active: linkIsActive('/withdraw') }"
          ></i>
          <span
            class="nav-text"
            :class="{ active: linkIsActive('/withdraw') }"
          >
            {{ $t('setting.withdraw') }}
          </span>
        </div>
      </li>

      <li
        class="nav-item"
        @click="() => {
          if ($route.path !== '/deposit') {
            $router.push('/deposit')
          }
        }"
      >
        <div class="nav-link">
          <i
            class="fas fa-coins nav-icon"
            :class="{ active: linkIsActive('/deposit') }"
          ></i>
          <span
            class="nav-text"
            :class="{ active: linkIsActive('/deposit') }"
          >
            {{ $t('setting.deposit') }}
          </span>
        </div>
      </li>

      <li
        class="nav-item"
        @click="() => {
          if ($route.path !== '/setting') {
            $router.push('/setting')
          }
        }"
      >
        <div class="nav-link">
          <i
            class="fas fa-user nav-icon"
            :class="{ active: linkIsActive('/setting') }"
          ></i>
          <span
            class="nav-text"
            :class="{ active: linkIsActive('/setting') }"
          >
            {{ $t('footer.profile') }}
          </span>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  methods: {
    linkIsActive(link) {
      return this.$route.path === link;
    },
  },
};
</script>

<style scoped>
.footer {
  position: fixed;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  max-width: 420px;
  width: 100%;
  background-color: #2b1c59;
  padding: 0.8rem;
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
  z-index: 1000;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.25);
}

.footer ul {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0;
  margin: 0;
  list-style: none;
}

.nav-item {
  flex: 1;
  text-align: center;
  cursor: pointer;
}

.nav-link {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.nav-icon {
  font-size: 1.3rem;
  color: #adacb1;
  transition: color 0.3s, transform 0.2s;
}

.nav-icon.active {
  color: #ffffff;
  transform: scale(1.15);
}

.nav-text {
  margin-top: 0.2rem;
  font-size: 0.9rem;
  font-weight: 500;
  color: #adacb1;
  transition: color 0.3s;
}

.nav-text.active {
  color: #ffffff;
}
</style>
